// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactItem_wrapper__2Y64S","title":"ContactItem_title__2f7I2","name":"ContactItem_name__1bT_p","contact":"ContactItem_contact__3ZUAd"};